import { connect } from 'react-redux';
import { publishDraftTier } from '../../Tier/redux/creator/actions';
import { pushModal } from '../../Modals/redux/actionCreators';
import { ModalType } from '../../Modals/redux/types';
var mapStateToProps = function (state) { return ({}); };
var mapDispatchToProps = function (dispatch, props) { return ({
    onPublish: function (params) { return dispatch(publishDraftTier(params)); },
    onSubmitToTier: function () {
        var _a;
        return dispatch(pushModal(ModalType.DEVIATION_SUBMIT, {
            params: { tierId: (_a = props === null || props === void 0 ? void 0 : props.deviation) === null || _a === void 0 ? void 0 : _a.deviationId },
        }));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=TierProductCard.container.js.map